import { Box, createStyles, Link, makeStyles, Theme } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * CheckoutLayout Props Interface
 */
interface OdsLayoutProps {
  children1?: React.ReactElement;
  children2?: React.ReactElement;
}

export const OdsLayout: FC<OdsLayoutProps> = ({ children1, children2 }) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {},
      content: {
        maxWidth: '80em',
        marginRight: 'auto',
        marginLeft: 'auto',
        padding: theme.spacing(4, 2)
      },
      contentTop: {
        [theme.breakpoints.down('sm')]: {
          paddingTop: 0
        }
      },
      contentBottom: {
        [theme.breakpoints.down('sm')]: {
          paddingBottom: 0
        }
      },
      footer: {},
      footerInfo: {
        whiteSpace: 'nowrap',
        fontSize: '12px',
        color: CORPORATE_COLORS.DARK_GRAY
      },
      footerLinksWrapper: {
        whiteSpace: 'nowrap'
      },
      footerLink: {
        fontWeight: 'normal',
        margin: '0 .5rem',
        color: CORPORATE_COLORS.DARK_GRAY,
        fontSize: '14px',
        textDecoration: 'underline'
      },
      arrowIcon: {
        color: CORPORATE_COLORS.PRIMARY
      }
    })
  );

  const classes = useStyles();

  return (
    <>
      <Box bgcolor={CORPORATE_COLORS.BACKGROUND_PRIMARY_MEDIUM}>
        <Box
          display="flex"
          p={2.5}
          pt={3.7}
          component="div"
          flex="1"
          className={`${classes.content} ${classes.contentTop}`}
        >
          {!mobile && (
            <Box width="12rem" justifyContent="center" alignItems="center">
              <Box display="flex" flexDirection="row">
                <ArrowBackIcon className={classes.arrowIcon} />
                <Box fontWeight="bold" pt={0.3}>
                  <Link onClick={() => navigate(-1)} style={{ textDecoration: 'none', paddingLeft: '0.5rem' }}>
                    Zurück
                  </Link>
                </Box>
              </Box>
            </Box>
          )}
          <Box flex={1}>{children1}</Box>
        </Box>
      </Box>

      <Box display="flex" p={2.5} component="div" flex="1" className={`${classes.content} ${classes.contentBottom}`}>
        {!mobile && <Box width="12rem">{/*Placeholder*/}</Box>}
        <Box flex={1}>{children2}</Box>
      </Box>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        #ods-client {
          width: 99.5vw;
        }

        html, body {
          overflow-x: hidden;
          padding: 0;
          margin: 0;
        }

        .o-CmsContent__ComponentHeading {
          display: none;
        }

        @media screen and (min-width: 45em) {
            .u-padding-x-large--top\\@medium {
                padding-top: 0;
            }
        }
      `
        }}
      />
    </>
  );
};
